var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerizonLogoLatest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 22,
    viewBox: "-4 0 105 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_1967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8636 21.0864H90.8382V12.4274C90.8382 10.4523 92.0499 9.05451 93.8356 9.05451C95.5575 9.05451 96.4504 10.2094 96.4504 11.8502V21.0865H101.425V10.9389C101.425 7.5051 99.2568 5.0744 95.7489 5.0744C93.5169 5.0744 91.9542 5.98606 90.7743 7.65707H90.6786V5.53031H85.8635V21.0864H85.8636ZM76.1057 5.10477C70.9077 5.10477 67.4322 8.65965 67.4322 13.3387C67.4322 17.9876 70.9079 21.5728 76.1057 21.5728C81.3035 21.5728 84.7792 17.9876 84.7792 13.3387C84.7792 8.65949 81.3035 5.10477 76.1057 5.10477ZM76.0738 18.0785C73.7138 18.0785 72.4705 16.195 72.4705 13.3387C72.4705 10.4523 73.7138 8.59876 76.0738 8.59876C78.4334 8.59876 79.7409 10.4521 79.7409 13.3387C79.7409 16.195 78.4334 18.0785 76.0738 18.0785ZM53.2734 21.0864H67.2407V17.3495H59.3324V17.2579L66.89 9.17596V5.53031H53.2734V9.2672H60.9267V9.35845L53.2734 17.5011V21.0864ZM46.8951 21.0864H51.9015V5.53031H46.8951V21.0864ZM35.2876 21.0864H40.2622V13.9466C40.2622 10.6953 42.3031 9.2672 45.4281 9.66238H45.5238V5.56067C45.2686 5.46943 44.9818 5.43906 44.5035 5.43906C42.5583 5.43906 41.2508 6.28967 40.1345 8.11266H40.0388V5.53031H35.2876V21.0864ZM26.1358 18.1092C23.9353 18.1092 22.5961 16.7415 22.3409 14.6455H34.1077C34.1396 11.3029 33.2146 8.62913 31.2695 6.95811C29.8986 5.74284 28.0806 5.07425 25.7847 5.07425C20.8742 5.07425 17.4619 8.62912 17.4619 13.2778C17.4619 17.9567 20.7146 21.542 26.1037 21.542C28.1446 21.542 29.7708 21.0255 31.1102 20.1442C32.5453 19.2028 33.5655 17.8351 33.8523 16.468H29.0692C28.5911 17.5011 27.6024 18.1092 26.1358 18.1092ZM25.8805 8.47716C27.6343 8.47716 28.846 9.72327 29.0374 11.5461H22.3728C22.7556 9.69243 23.8077 8.47716 25.8805 8.47716ZM46.8951 0H51.9015V4.22348H46.8951V0Z",
    fill: "#F50A23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6369 20.8928L5.44691 5.53027H0.425049L6.61504 20.8928C6.662 21.01 6.77991 21.0867 6.91106 21.0867H11.9329C11.8018 21.0867 11.6839 21.01 11.6369 20.8928Z",
    fill: "url(#paint0_radial_357_1967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2069 20.8928L13.3969 5.53027H18.4188L12.2288 20.8928C12.1818 21.01 12.0639 21.0867 11.9328 21.0867H6.91089C7.04221 21.0867 7.16011 21.01 7.2069 20.8928Z",
    fill: "#F50A23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_357_1967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9005 18.416) rotate(-69.2466) scale(8.30236 9.3175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#F5FF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#F5FA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#F5A620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#F56321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6779,
    stopColor: "#F53322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    stopColor: "#F51523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8155,
    stopColor: "#F50A23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_1967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 21.5728,
    fill: "white",
    transform: "translate(0.425049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerizonLogoLatest);
export default __webpack_public_path__ + "static/media/Verizon_logo-latest.66266d565a22ed640e58ef0553e23d12.svg";
export { ForwardRef as ReactComponent };